module.exports = __webpack_public_path__ + "static/img/server.7b59a35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/features/server.png
// module id = S4Fv
// module chunks = 6